import { useEffect, useMemo, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPReactQueryKeys } from '../types'

interface Params {
    isBasicMetasLoading: boolean
}

export default function usePLPInitialLoading({ isBasicMetasLoading }: Params) {
    const { searchParams } = usePLPFacetsContext()
    const [isLoading, setIsLoading] = useState(true)

    const queryClient = useQueryClient()
    const queryKey = useMemo(() => [PLPReactQueryKeys.PagesData, searchParams], [searchParams])

    const enabled = !isBasicMetasLoading && !!searchParams

    useEffect(() => {
        if (!enabled) return

        const init = async () => {
            await queryClient.refetchQueries({ queryKey, exact: true })

            setIsLoading(false)
        }

        init()
    }, [queryClient, queryKey, enabled])

    return isLoading
}
